/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Btn_SendingInputs */

const es_ab_btn_sending = /** @type {(inputs: Ab_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const gl_ab_btn_sending = /** @type {(inputs: Ab_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const en_ab_btn_sending = /** @type {(inputs: Ab_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Ab_Btn_SendingInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_btn_sending = /** @type {((inputs?: Ab_Btn_SendingInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Btn_SendingInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_btn_sending(inputs)
	if (locale === "en") return en_ab_btn_sending(inputs)
	return es_ab_btn_sending(inputs)
});